import React, { Component } from "react";
import { connect } from "react-redux";
import { API_URL } from "../../../config";
import "./CampaignDetailsTab2.css";
import ConnectRateIcon from "../../assets/marketing.svg";
import TotalEngagedIcon from "../../assets/market.svg";
import TotalOpenIcon from "../../assets/openContact.png";
import TotalLeadIcon from "../../assets/target.svg";
import TotalinvitesentIcon from "../../assets/invitesent.png";
import Step001 from "../../assets/step001.png";
import Step01 from "../../assets/step01.png";
import Step02 from "../../assets/step02.png";
import Step1 from "../../assets/step1.png";
import Step2 from "../../assets/step2.png";
import Step3 from "../../assets/step3.png";
import Step21 from "../../assets/step21.png";
import Step22 from "../../assets/step22.png";
import Step23 from "../../assets/step23.png";
import Step24 from "../../assets/step24.png";

import Step31 from "../../assets/step31.png";
import Step32 from "../../assets/step32.png";
import Step33 from "../../assets/step33.png";
import Step34 from "../../assets/step34.png";
import Step35 from "../../assets/step35.png";

import { fetchMethod } from "../../../../src/FetchMethod";
import { campaignDetails } from "../../../Queries";

import colorLib from "@kurkle/color";

import { Line } from "react-chartjs-2";
import MediaCard5 from "../../Card/Card5";
import MediaCard6 from "../../Card/TriggersCard";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

class CampaignDetailsTab2 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      name: "",
      description: "",
      customer: "",
      campManagerFirstName: "",
      campManagerLastName: "",
      campAdminFirstName: "",
      campAdminLastName: "",
      linkedInProfile: "",
      status: "",
      selectedCampaignStatus: "",
      campaignid: 0,
      connectionsToBeSent: "",
      startDate: "",
      startTime: "",
      steps: [],
      show: false,
      DashboardData2: {
        TotalSent: 0,
        TotalConnection: 0,
        TotalEngagedCon: 0,
        TotalLeadsCon: 0,

        step1: 0,
        step2: 0,
        step3: 0,
        step4: 0,
        step5: 0,

        step2Remain: 0,
        step3Remain: 0,
        step4Remain: 0,
        step5Remain: 0,
        step2Remain1st: 0,

        stepLength: 0,
        TotalConnectRate: "",
        LiveConnectRate: "",
        TotalEngaged: "",
        LiveEngaged: "",
        TotalLeads: "",
        LiveLeads: "",
        newRecentdata: "",
        recentLeads: [],
        recentcontactCount: [],
        openContactCount: 0,
        TotalOpenRate: "",
      },
      opencontact: "",
    };
  }

  componentDidMount() {
    this.getDashboardData2();
    this.fetchDetails(this.props.campaignId);
  }

  fetchDetails = (campaignId) => {
    fetchMethod(campaignDetails(campaignId))
      .then((response) => {
        return response.json();
      })
      .then((responseAsJson) => {
        this.setState(
          {
            loading: false,
            show: true,
          },
          () => this.props.detailEdit(this.state.show)
        );
        this.setDetails(responseAsJson);
      })
      .catch((e) => {
        console.log(e);
        this.setState({ loading: true });
      });
  };

  setDetails = (response) => {
    this.setState(
      {
        name: response.data.Campaigns.name,
        description: response.data.Campaigns.description,
        status: response.data.Campaigns.status,
        selectedCampaignStatus: response.data.Campaigns.status,
        campaignid: response.data.Campaigns.id,
        connectionsToBeSent: response.data.Campaigns.targetconnections,
        connectionsToBeSent: response.data.Campaigns.zapierurl,
        startDate: response.data.Campaigns.startdate,
        steps:
          response.data.Campaigns.Campaignstepfk !== undefined
            ? response.data.Campaigns.Campaignstepfk.Campaignsteps
            : "",
        opencontact: response.data.Campaigns.opencontact,
      },
      () => {
        this.state.steps.sort(function (a, b) {
          return a.sequence - b.sequence;
        });
        this.props.name(this.state.name);
      }
    );
  };

  getDashboardData2 = () => {
    // var dasId = 0;
    // if (localStorage.getItem("role") == "CUSTOMER") {
    //   dasId = localStorage.getItem("customer");
    // } else {
    //   dasId = localStorage.getItem("id");
    // }

    fetch(
      `${API_URL}/api/Campaigns/getCampaignHomeDas?campaignId=${
        this.props.campaignId
      }&access_token=${localStorage.getItem("token")}`,
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-type": "application/json",
        },
      }
    )
      .then((res) => res.json())
      // .then(res => {

      .then((res) => {
        this.setState(
          {
            DashboardlistData2: res.response,
          },
          () => {
            this.setDataCalculation2();
          }
        );
      })
      .catch((e) => {
        console.log(e);
      });
  };

  setDataCalculation2 = () => {
    const { DashboardlistData2, DashboardData2 } = this.state;

    var engData = "0";
    var leadData = "0";
    var connectData = "0";
    var openContactData = "0";

    if (DashboardlistData2[1].engagedRate != null) {
      engData = DashboardlistData2[1].engagedRate.toFixed(0);
    }
    if (DashboardlistData2[2].leadsRate != null) {
      leadData = DashboardlistData2[2].leadsRate.toFixed(0);
    }
    if (DashboardlistData2[0].connectRate != null) {
      connectData = DashboardlistData2[0].connectRate.toFixed(0);
    }
    if (DashboardlistData2[17] != null) {
      openContactData = DashboardlistData2[17].toFixed(0);
    }

    DashboardData2.TotalSent = DashboardlistData2[3];
    DashboardData2.TotalConnection = DashboardlistData2[6];
    DashboardData2.TotalEngagedCon = DashboardlistData2[5];
    DashboardData2.TotalLeadsCon = DashboardlistData2[4];
    DashboardData2.TotalEngaged = engData;
    DashboardData2.TotalLeads = leadData;
    DashboardData2.TotalConnectRate = connectData;
    DashboardData2.recentLeads = DashboardlistData2[7];
    DashboardData2.recentTrigger = DashboardlistData2[8];
    DashboardData2.stepLength = DashboardlistData2[12].stepContacts.length;
    DashboardData2.openContactCount = DashboardlistData2[16];
    DashboardData2.TotalOpenRate = openContactData;

    var TotalLength = DashboardlistData2[12].stepContacts.length;
    var flag = 0;

    for (var i = 0; i < TotalLength; i++) {
      var index = i + flag;

      var name = DashboardlistData2[12].stepContacts[i].stepname;

      if (name === "VISIT") {
        name = "Visit";
      }
      if (name === "FOLLOW") {
        name = "Follow";
      }
      if (name === "SEND_INVITE") {
        name = "Connections";
      }
      if (name === "SEND_THANKS_MESSAGE") {
        name = "Thank You Message";
      }
      if (name === "SEND_MESSAGE") {
        name = "Send Message";
      }
      if (name === "SEND_EMAIL") {
        name = "Send Inmail";
      }

      if (
        i === 0 &&
        (DashboardlistData2[12].stepContacts[0].stepname === "SEND_EMAIL" ||
          DashboardlistData2[12].stepContacts[0].stepname === "SEND_MESSAGE")
      ) {
        DashboardData2.stepLength = DashboardData2.stepLength + 1;

        DashboardData2.step1 = DashboardlistData2[15];
        DashboardData2.stepname1 = "Connections";
        flag = 1;

        if (DashboardlistData2[12].stepContacts[0].stepname == "SEND_EMAIL") {
          DashboardData2.step2 =
            DashboardlistData2[12].stepContacts[0].totalDone;
          DashboardData2.step2Remain1st =
            DashboardlistData2[15] -
            DashboardlistData2[12].stepContacts[0].totalDone;
        } else {
          DashboardData2.step2 =
            DashboardlistData2[12].stepContacts[0].totalCount;
          DashboardData2.step2Remain1st =
            DashboardlistData2[15] -
            DashboardlistData2[12].stepContacts[0].totalCount;
        }
        // DashboardData2.step2 = DashboardlistData2[12].stepContacts[0].totalCount;
        DashboardData2.stepname2 = name;
        // DashboardData2.step2Remain1st = (DashboardlistData2[15]) -(DashboardlistData2[12].stepContacts[0].totalCount) ;
      } else {
        switch (index) {
          case 0:
            DashboardData2.step1 = DashboardData2.TotalConnection;
            DashboardData2.stepname1 = "Connections";

            break;
          case 1:
            DashboardData2.step2 =
              DashboardlistData2[12].stepContacts[i].totalDone;
            DashboardData2.stepname2 = name;
            DashboardData2.step2Remain =
              DashboardlistData2[12].stepContacts[i].totalPen;
            break;
          case 2:
            DashboardData2.step3 =
              DashboardlistData2[12].stepContacts[i].totalDone;
            DashboardData2.stepname3 = name;
            DashboardData2.step3Remain =
              DashboardlistData2[12].stepContacts[i].totalPen +
              DashboardData2.step2Remain;
            break;
          case 3:
            DashboardData2.step4 =
              DashboardlistData2[12].stepContacts[i].totalDone;
            DashboardData2.stepname4 = name;
            DashboardData2.step4Remain =
              DashboardlistData2[12].stepContacts[i].totalPen +
              DashboardData2.step3Remain;
            break;

          case 4:
            DashboardData2.step5 =
              DashboardlistData2[12].stepContacts[i].totalDone;
            DashboardData2.stepname5 = name;
            DashboardData2.step5Remain =
              DashboardlistData2[12].stepContacts[i].totalPen +
              DashboardData2.step4Remain;
            break;
        }
      }
    }

    this.setState({
      DashboardlistData2,
      loading: false,
    });
  };

  render() {
    const options = {
      animations: {
        y: {
          easing: "easeInOutElastic",
          from: (ctx) => {
            if (ctx.type === "data") {
              if (ctx.mode === "default" && !ctx.dropped) {
                ctx.dropped = true;
                return 0;
              }
            }
          },
        },
      },
      plugins: {
        filler: {
          propagate: true,
        },
      },
    };

    //var campaignStatus = "";
    var monthsData = [];
    var monthsCount = [];
    var monthsEngCount = [];
    var monthsleaCount = [];

    if (this.state.DashboardlistData2 !== undefined) {
      // campaignStatus = this.state.DashboardlistData2[13][0].status;
    
      var datacount = this.state.DashboardlistData2[9];
      var engcount = this.state.DashboardlistData2[10];
      var leacount = this.state.DashboardlistData2[11];

      var connectList = datacount[0];
      // var dataLeng = datacount[0].length;

      for (var i = 0; i < datacount[0].length; i++) {
        // const d = new Date();
        // let curMonth = d.getMonth() +1;
        // let curYear = d.getFullYear();
        var months = connectList[i].month;
        if (i === datacount[0].length - 1) {
          let connect =
            this.state.DashboardlistData2[0].connectRate != null
              ? this.state.DashboardlistData2[0].connectRate.toFixed(0)
              : 0;
          monthsCount.push(connect);
        } else {
          monthsCount.push(connectList[i].countdata);
        }

        switch (months) {
          case 1:
            monthsData.push("Jan");
            break;
          case 2:
            monthsData.push("Feb");
            break;
          case 3:
            monthsData.push("Mar");
            break;
          case 4:
            monthsData.push("Apr");
            break;
          case 5:
            monthsData.push("May");
            break;
          case 6:
            monthsData.push("Jun");
            break;
          case 7:
            monthsData.push("Jul");
            break;
          case 8:
            monthsData.push("Aug");
            break;
          case 9:
            monthsData.push("Sep");
            break;
          case 10:
            monthsData.push("Oct");
            break;
          case 11:
            monthsData.push("Nov");
            break;
          case 12:
            monthsData.push("Dec");
            break;
        }
      }

      var engagedList = engcount[0];
      var leadList = leacount[0];
      for (var i = 0; i < engcount[0].length; i++) {
        // const d = new Date();
        // let curMonth = d.getMonth() +1;
        // let curYear = d.getFullYear();
        if (i === engcount[0].length - 1) {
          let engaged =
            this.state.DashboardlistData2[1].engagedRate != null
              ? this.state.DashboardlistData2[1].engagedRate.toFixed(0)
              : 0;
          monthsEngCount.push(engaged);
        } else {
          monthsEngCount.push(engagedList[i].countdata);
        }
      }
      for (var i = 0; i < leacount[0].length; i++) {
        //const d = new Date();
        // let curMonth = d.getMonth() +1;
        // let curYear = d.getFullYear();
        if (i === leacount[0].length - 1) {
          let leads =
            this.state.DashboardlistData2[2].leadsRate != null
              ? this.state.DashboardlistData2[2].leadsRate.toFixed(0)
              : 0;
          monthsleaCount.push(leads);
        } else {
          monthsleaCount.push(leadList[i].countdata);
        }
      }
    }

    const labels = monthsData;
    const CHART_COLORS = {
      red: "rgb(255, 99, 132)",
      orange: "rgb(255, 102, 0)",
      yellow: "rgb(255, 205, 86)",
      green: "rgb(43,	173,	221)",
      blue: "rgb(0, 125, 150)",
      purple: "rgb(153, 102, 255)",
      grey: "rgb(201, 203, 207)",
    };
    function transparentize(value, opacity) {
      var alpha = opacity === undefined ? 0.5 : 1 - opacity;
      return colorLib(value).alpha(alpha).rgbString();
    }
    const type = "line";
    const datasets = [];
    const data = {
      labels,
      datasets,
    };

    if (this.state.DashboardlistData2 !== undefined) {
      if (this.state.DashboardlistData2[12].stepContacts[0] !== undefined) {
        if (
          this.state.DashboardlistData2[12].stepContacts[0].stepname ===
            "SEND_EMAIL" ||
          this.state.DashboardlistData2[12].stepContacts[0].stepname ===
            "SEND_MESSAGE"
        ) {
          datasets.push(
            {
              animations: {
                y: {
                  duration: 1000,
                  delay: 500,
                },
              },
              label: `Engaged%`,
              data: monthsEngCount,

              borderColor: "#007D96",
              backgroundColor: transparentize(CHART_COLORS.blue, 0.8),
              fill: true,
              tension: 0.5,
            },
            {
              label: "Leads%",
              data: monthsleaCount,

              borderColor: "#FF6600",
              backgroundColor: transparentize(CHART_COLORS.orange, 0.8),
              fill: true,
              tension: 0.5,
            }
          );
        } else {
          datasets.push(
            {
              label: "Connect%",

              animations: {
                y: {
                  duration: 1000,
                  delay: 500,
                },
              },

              data: monthsCount,

              borderColor: "#2BADDD",
              backgroundColor: transparentize(CHART_COLORS.green, 0.8),
              fill: true,
              tension: 0.5,
            },

            {
              label: `Engaged%`,
              data: monthsEngCount,

              borderColor: "#007D96",
              backgroundColor: transparentize(CHART_COLORS.blue, 0.8),
              fill: true,
              tension: 0.5,
            },
            {
              label: "Leads%",
              data: monthsleaCount,

              borderColor: "#FF6600",
              backgroundColor: transparentize(CHART_COLORS.orange, 0.8),
              fill: true,
              tension: 0.5,
            }
          );
        }
      } else {
        datasets.push(
          {
            label: "Connect%",

            animations: {
              y: {
                duration: 1000,
                delay: 500,
              },
            },

            data: monthsCount,

            borderColor: "#2BADDD",
            backgroundColor: transparentize(CHART_COLORS.green, 0.8),
            fill: true,
            tension: 0.5,
          },
          {
            label: `Engaged%`,
            data: monthsEngCount,

            borderColor: "#007D96",
            backgroundColor: transparentize(CHART_COLORS.blue, 0.8),
            fill: true,
            tension: 0.5,
          },
          {
            label: "Leads%",
            data: monthsleaCount,

            borderColor: "#FF6600",
            backgroundColor: transparentize(CHART_COLORS.orange, 0.8),
            fill: true,
            tension: 0.5,
          }
        );
      }
    }

    // var cc = this.state.DashboardlistData2;
    var today = new Date();
    // var curHr = today.getHours();

    const onNameClick = (row) => {
      this.props.onHandleCampaign(row);
      localStorage.setItem("label", "Leads");
      localStorage.setItem("path", "/campaigns");
    };
    const onNameClick2 = (row) => {
      this.props.onHandleCampaign(row);
      localStorage.setItem("label", "Trigger");
      localStorage.setItem("path", "/campaigns");
    };
    return (
      <div className="homePageSection">
        <div className="gridContainer">
          <div className="greetFlexBox"></div>
        </div>

        <div className="main_campaign">
          <div className="main_right">
            <div className="campaign_data">
              {this.state.DashboardlistData2 !== undefined && (
                <div className="campaign_data_graph">
                  <Line type={type} data={data} options={options} />
                </div>
              )}
              {this.state.DashboardlistData2 !== undefined &&
              this.state.DashboardlistData2[12].stepContacts[0] ? (
                <div className="campaign_data_stats0">
                  {(this.state.DashboardlistData2[12].stepContacts[0]
                    .stepname === "SEND_EMAIL" ||
                    this.state.DashboardlistData2[12].stepContacts[0]
                      .stepname === "SEND_MESSAGE") && (
                    <div className="campaign_data_stats">
                      <div className="data_stats_card">
                        <div>
                          <h2>{this.state.DashboardData2.step1} </h2>{" "}
                          <p>
                            {" "}
                            <p></p> Total Connections
                          </p>
                        </div>

                        <div className="icons">
                          <img src={ConnectRateIcon} alt="users" />
                        </div>
                      </div>

                      <div className="data_stats_card">
                        <div>
                          <h2>
                            {(
                              (this.state.DashboardData2.step2 /
                                this.state.DashboardData2.step1) *
                              100
                            ).toFixed(0)}
                            % ({this.state.DashboardData2.step2}){" "}
                          </h2>
                          <p>Message Sent</p>
                        </div>
                        <div className="icons">
                          <img src={TotalinvitesentIcon} alt="users" />
                        </div>
                      </div>
                      {/* {this.state.opencontact === 1 && ( */}
                        <div className="data_stats_card">
                          <div>
                            <h2>
                              {this.state.DashboardData2.TotalOpenRate}% (
                              {this.state.DashboardData2.openContactCount})
                            </h2>
                            <p>Total Open Profiles</p>
                          </div>
                          <div className="icons">
                            <img src={TotalOpenIcon} alt="users" />
                          </div>
                        </div>
                      {/* )} */}
                      <div className="data_stats_card">
                        <div>
                          <h2>
                            {(
                              (this.state.DashboardData2.TotalEngagedCon /
                                this.state.DashboardData2.step2) *
                              100
                            ).toFixed(0)}
                            % ({this.state.DashboardData2.TotalEngagedCon})
                          </h2>
                          <p>Total Engaged</p>
                        </div>
                        <div className="icons">
                          <img src={TotalEngagedIcon} alt="users" />
                        </div>
                      </div>
                      <div className="data_stats_card">
                        <div>
                          <h2>
                            {(
                              (this.state.DashboardData2.TotalLeadsCon /
                                this.state.DashboardData2.step2) *
                              100
                            ).toFixed(0)}
                            % ({this.state.DashboardData2.TotalLeadsCon})
                          </h2>
                          <p>Total Leads</p>
                        </div>
                        <div>
                          <h2>
                            {" "}
                            <div className="icons">
                              <img src={TotalLeadIcon} alt="users" />
                            </div>
                          </h2>
                        </div>
                      </div>
                    </div>
                  )}

                  {this.state.DashboardlistData2[12].stepContacts[0]
                    .stepname !== "SEND_EMAIL" &&
                    this.state.DashboardlistData2[12].stepContacts[0]
                      .stepname !== "SEND_MESSAGE" && (
                      <div className="campaign_data_stats">
                        <div className="data_stats_card">
                          <div>
                            <h2>{this.state.DashboardData2.TotalSent}</h2>
                            <p>Invitation Sent</p>
                          </div>
                          <div className="icons">
                            <img src={TotalinvitesentIcon} alt="users" />
                          </div>
                        </div>
                        <div className="data_stats_card">
                          <div>
                            <h2>
                              {this.state.DashboardData2.TotalConnectRate}% (
                              {this.state.DashboardData2.TotalConnection}){" "}
                            </h2>{" "}
                            <p>
                              {" "}
                              <p></p> Total Connections
                            </p>
                          </div>

                          <div className="icons">
                            <img src={ConnectRateIcon} alt="users" />
                          </div>
                        </div>
                        {/* {this.state.opencontact === 1 && ( */}
                          <div className="data_stats_card">
                            <div>
                              <h2>
                                {this.state.DashboardData2.TotalOpenRate}% (
                                {this.state.DashboardData2.openContactCount})
                              </h2>
                              <p>Total Open Profiles</p>
                            </div>
                            <div className="icons">
                              <img src={TotalOpenIcon} alt="users" />
                            </div>
                          </div>
                        {/* )} */}
                        <div className="data_stats_card">
                          <div>
                            <h2>
                              {this.state.DashboardData2.TotalEngaged}% (
                              {this.state.DashboardData2.TotalEngagedCon})
                            </h2>
                            <p>Total Engaged</p>
                          </div>
                          <div className="icons">
                            <img src={TotalEngagedIcon} alt="users" />
                          </div>
                        </div>
                        <div className="data_stats_card">
                          <div>
                            <h2>
                              {this.state.DashboardData2.TotalLeads}% (
                              {this.state.DashboardData2.TotalLeadsCon})
                            </h2>
                            <p>Total Leads</p>
                          </div>
                          <div>
                            <h2>
                              {" "}
                              <div className="icons">
                                <img src={TotalLeadIcon} alt="users" />
                              </div>
                            </h2>
                          </div>
                        </div>
                      </div>
                    )}
                </div>
              ) : (
                <div className="campaign_data_stats0">
                  <div className="campaign_data_stats">
                    <div className="data_stats_card">
                      <div>
                        <h2>{this.state.DashboardData2.TotalSent}</h2>
                        <p>Invitation Sent</p>
                      </div>
                      <div className="icons">
                        <img src={TotalinvitesentIcon} alt="users" />
                      </div>
                    </div>
                    <div className="data_stats_card">
                      <div>
                        <h2>
                          {this.state.DashboardData2.TotalConnectRate}% (
                          {this.state.DashboardData2.TotalConnection}){" "}
                        </h2>{" "}
                        <p>
                          {" "}
                          <p></p> Total Connections
                        </p>
                      </div>

                      <div className="icons">
                        <img src={ConnectRateIcon} alt="users" />
                      </div>
                    </div>
                    {/* {this.state.opencontact === 1 && ( */}
                      <div className="data_stats_card">
                        <div>
                          <h2>
                            {this.state.DashboardData2.TotalOpenRate}% (
                            {this.state.DashboardData2.openContactCount})
                          </h2>
                          <p>Total Open Profiles</p>
                        </div>
                        <div className="icons">
                          <img src={TotalOpenIcon} alt="users" />
                        </div>
                      </div>
                  {/* )} */}
                    <div className="data_stats_card">
                      <div>
                        <h2>
                          {this.state.DashboardData2.TotalEngaged}% (
                          {this.state.DashboardData2.TotalEngagedCon})
                        </h2>
                        <p>Total Engaged</p>
                      </div>
                      <div className="icons">
                        <img src={TotalEngagedIcon} alt="users" />
                      </div>
                    </div>
                    <div className="data_stats_card">
                      <div>
                        <h2>
                          {this.state.DashboardData2.TotalLeads}% (
                          {this.state.DashboardData2.TotalLeadsCon})
                        </h2>
                        <p>Total Leads</p>
                      </div>
                      <div>
                        <h2>
                          {" "}
                          <div className="icons">
                            <img src={TotalLeadIcon} alt="users" />
                          </div>
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="campaign_data_stats_2">
                {this.state.DashboardData2.stepLength > 0 && (
                  <div className="campaign_data_stats_3">
                    <div className="boader">
                      {this.state.DashboardData2.stepLength === 1 && (
                        <div className="data_stats_card_2">
                          <div className="icons_2">
                            <img src={Step001} alt="users" />

                            <div className="icons_3">
                              <h3>{this.state.DashboardData2.step1}</h3>
                              <p>{this.state.DashboardData2.stepname1}</p>
                            </div>
                          </div>
                        </div>
                      )}
                      {this.state.DashboardData2.stepLength === 2 && (
                        <div className="ata_stats_card_2">
                          <div className="icons_2">
                            <img src={Step01} alt="users" />

                            <div className="icons_3">
                              <h3>{this.state.DashboardData2.step1}</h3>
                              <p>{this.state.DashboardData2.stepname1}</p>
                            </div>
                          </div>
                          <div className="icons_2">
                            <img src={Step02} alt="users" />
                            <div className="icons_3">
                              <h3>
                                {this.state.DashboardData2.step2 +
                                  " out of " +
                                  (this.state.DashboardData2.step2Remain +
                                    this.state.DashboardData2.step2 +
                                    this.state.DashboardData2.step2Remain1st)}
                              </h3>
                              <p>{this.state.DashboardData2.stepname2}</p>
                            </div>
                          </div>
                        </div>
                      )}
                      {this.state.DashboardData2.stepLength === 3 && (
                        <div className="ata_stats_card_2">
                          <div className="icons_2">
                            <img src={Step1} alt="users" />

                            <div className="icons_3">
                              <h3>{this.state.DashboardData2.step1}</h3>
                              <p>{this.state.DashboardData2.stepname1}</p>
                            </div>
                          </div>
                          <div className="icons_2">
                            <img src={Step2} alt="users" />
                            <div className="icons_3">
                              <h3>
                                {this.state.DashboardData2.step2 +
                                  " out of " +
                                  (this.state.DashboardData2.step2Remain +
                                    this.state.DashboardData2.step2 +
                                    this.state.DashboardData2.step2Remain1st)}
                              </h3>
                              <p>{this.state.DashboardData2.stepname2}</p>
                            </div>
                          </div>
                          <div className="icons_2">
                            <img src={Step3} alt="users" />
                            <div className="icons_3">
                              <h3>
                                {this.state.DashboardData2.step3 +
                                  " out of " +
                                  (this.state.DashboardData2.step3Remain +
                                    this.state.DashboardData2.step3)}
                              </h3>
                              <p>{this.state.DashboardData2.stepname3}</p>
                            </div>
                          </div>
                        </div>
                      )}
                      {this.state.DashboardData2.stepLength === 4 && (
                        <div className="ata_stats_card_2">
                          <div className="icons_2">
                            <img src={Step21} alt="users" />

                            <div className="icons_3">
                              <h3>{this.state.DashboardData2.step1}</h3>
                              <p>{this.state.DashboardData2.stepname1}</p>
                            </div>
                          </div>
                          <div className="icons_2">
                            <img src={Step22} alt="users" />
                            <div className="icons_3">
                              <h3>
                                {this.state.DashboardData2.step2 +
                                  " out of " +
                                  (this.state.DashboardData2.step2Remain +
                                    this.state.DashboardData2.step2 +
                                    this.state.DashboardData2.step2Remain1st)}
                              </h3>
                              <p>{this.state.DashboardData2.stepname2}</p>
                            </div>
                          </div>
                          <div className="icons_2">
                            <img src={Step23} alt="users" />
                            <div className="icons_3">
                              <h3>
                                {this.state.DashboardData2.step3 +
                                  " out of " +
                                  (this.state.DashboardData2.step3Remain +
                                    this.state.DashboardData2.step3)}
                              </h3>
                              <p>{this.state.DashboardData2.stepname3}</p>
                            </div>
                          </div>
                          <div className="icons_2">
                            <img src={Step24} alt="users" />
                            <div className="icons_3">
                              <h3>
                                {this.state.DashboardData2.step4 +
                                  " out of " +
                                  (this.state.DashboardData2.step4Remain +
                                    this.state.DashboardData2.step4)}
                              </h3>
                              <p>{this.state.DashboardData2.stepname4}</p>
                            </div>
                          </div>
                        </div>
                      )}
                      {this.state.DashboardData2.stepLength === 5 && (
                        <div className="ata_stats_card_2">
                          <div className="icons_2">
                            <img src={Step31} alt="users" />

                            <div className="icons_3">
                              <h3>{this.state.DashboardData2.step1}</h3>
                              <p>{this.state.DashboardData2.stepname1}</p>
                            </div>
                          </div>
                          <div className="icons_2">
                            <img src={Step32} alt="users" />
                            <div className="icons_3">
                              <h3>
                                {this.state.DashboardData2.step2 +
                                  " out of " +
                                  (this.state.DashboardData2.step2Remain +
                                    this.state.DashboardData2.step2 +
                                    this.state.DashboardData2.step2Remain1st)}
                              </h3>
                              <p>{this.state.DashboardData2.stepname2}</p>
                            </div>
                          </div>
                          <div className="icons_2">
                            <img src={Step33} alt="users" />
                            <div className="icons_3">
                              <h3>
                                {this.state.DashboardData2.step3 +
                                  " out of " +
                                  (this.state.DashboardData2.step3Remain +
                                    this.state.DashboardData2.step3)}
                              </h3>
                              <p>{this.state.DashboardData2.stepname3}</p>
                            </div>
                          </div>
                          <div className="icons_2">
                            <img src={Step34} alt="users" />
                            <div className="icons_3">
                              <h3>
                                {this.state.DashboardData2.step4 +
                                  " out of " +
                                  (this.state.DashboardData2.step4Remain +
                                    this.state.DashboardData2.step4)}
                              </h3>
                              <p>{this.state.DashboardData2.stepname4}</p>
                            </div>
                          </div>
                          <div className="icons_2">
                            <img src={Step35} alt="users" />
                            <div className="icons_3">
                              <h3>
                                {this.state.DashboardData2.step5 +
                                  " out of " +
                                  (this.state.DashboardData2.step5Remain +
                                    this.state.DashboardData2.step5)}
                              </h3>
                              <p>{this.state.DashboardData2.stepname5}</p>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
            {this.state.DashboardlistData2 !== undefined && (
              <div className="campaign_recent">
                <div className="campaign_recent_jobs">
                  <h2 className="title" onClick={() => onNameClick(this.state)}>
                    {" "}
                    Recent Leads
                  </h2>

                  <div>
                    <MediaCard5 DashboardData={this.state.DashboardlistData2} />
                  </div>
                </div>
                <div className="campaign_recent_triggers">
                  <h2
                    className="title"
                    onClick={() => onNameClick2(this.state)}
                  >
                    Recent Triggers
                  </h2>
                  <MediaCard6 DashboardData={this.state.DashboardlistData2} />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    onHandleCampaign: (data) =>
      dispatch({
        type: "Campaign_Detail",
        payload: data,
      }),
  };
};

export default connect(null, mapDispatchToProps)(CampaignDetailsTab2);
